/* tslint:disable */
/* eslint-disable */
/**
 * SFTP Permissioning API
 * Here You can find all the endpoints for the Permission API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AddAssignmentDto } from '../models';
// @ts-ignore
import { AssignUsersPayloadDto } from '../models';
// @ts-ignore
import { AssignmentEntity } from '../models';
// @ts-ignore
import { BulkCreateUserDto } from '../models';
// @ts-ignore
import { CreateUserDto } from '../models';
// @ts-ignore
import { DeleteUserResponseDto } from '../models';
// @ts-ignore
import { I18nErrorResponseDto } from '../models';
// @ts-ignore
import { ManageUserAssignmentsDto } from '../models';
// @ts-ignore
import { ResetUserPassword200Response } from '../models';
// @ts-ignore
import { ResetUserPasswordDto } from '../models';
// @ts-ignore
import { SSHKeyEntity } from '../models';
// @ts-ignore
import { UpdateUserDto } from '../models';
// @ts-ignore
import { UserEntity } from '../models';
/**
 * SFTPUsersApi - axios parameter creator
 * @export
 */
export const SFTPUsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add assignment to user (partial update)
         * @param {string} userId ID of the user to assign assignments to
         * @param {AddAssignmentDto} addAssignmentDto Assignment to add
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAssignment: async (userId: string, addAssignmentDto: AddAssignmentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('addAssignment', 'userId', userId)
            // verify required parameter 'addAssignmentDto' is not null or undefined
            assertParamExists('addAssignment', 'addAssignmentDto', addAssignmentDto)
            const localVarPath = `/api/v1.0/users/{userId}/assignments`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addAssignmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add SSH key to user (partial update)
         * @param {string} userId ID of the user to add an SSH key for
         * @param {SSHKeyEntity} sSHKeyEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSSHKey: async (userId: string, sSHKeyEntity: SSHKeyEntity, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('addSSHKey', 'userId', userId)
            // verify required parameter 'sSHKeyEntity' is not null or undefined
            assertParamExists('addSSHKey', 'sSHKeyEntity', sSHKeyEntity)
            const localVarPath = `/api/v1.0/users/{userId}/sshkeys`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sSHKeyEntity, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update assignment membership for multiple users (bulk partial update)
         * @param {string} assignmentId ID of the assignment
         * @param {AssignUsersPayloadDto} assignUsersPayloadDto Payload containing users to add and remove from the assignment. Identifiers may be user &#x60;id&#x60; or &#x60;loginId&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignUsersToAssignment: async (assignmentId: string, assignUsersPayloadDto: AssignUsersPayloadDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('assignUsersToAssignment', 'assignmentId', assignmentId)
            // verify required parameter 'assignUsersPayloadDto' is not null or undefined
            assertParamExists('assignUsersToAssignment', 'assignUsersPayloadDto', assignUsersPayloadDto)
            const localVarPath = `/api/v1.0/users/assignments/{assignmentId}/assign-users`
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignUsersPayloadDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add and/or remove assignments from a user in a single operation
         * @summary Manage user assignments (add and remove)
         * @param {string} userId ID of the user to manage assignments for
         * @param {ManageUserAssignmentsDto} manageUserAssignmentsDto Assignment IDs to add and remove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkAssignAssignments: async (userId: string, manageUserAssignmentsDto: ManageUserAssignmentsDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('bulkAssignAssignments', 'userId', userId)
            // verify required parameter 'manageUserAssignmentsDto' is not null or undefined
            assertParamExists('bulkAssignAssignments', 'manageUserAssignmentsDto', manageUserAssignmentsDto)
            const localVarPath = `/api/v1.0/users/{userId}/assignments/bulk`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(manageUserAssignmentsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create multiple SFTP users in a single operation. Limited to 20 users per request due to CPU constraints. Each user follows the same validation and provisioning rules as single user creation. Users are processed independently - failures do not block other users. Assignments are optional and can be omitted.
         * @summary Create multiple users in bulk (max 20)
         * @param {BulkCreateUserDto} bulkCreateUserDto Array of users to create. Each user is validated independently.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkCreateUsers: async (bulkCreateUserDto: BulkCreateUserDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkCreateUserDto' is not null or undefined
            assertParamExists('bulkCreateUsers', 'bulkCreateUserDto', bulkCreateUserDto)
            const localVarPath = `/api/v1.0/users/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkCreateUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new user
         * @param {CreateUserDto} createUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: async (createUserDto: CreateUserDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createUserDto' is not null or undefined
            assertParamExists('createUser', 'createUserDto', createUserDto)
            const localVarPath = `/api/v1.0/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete SSH key of user
         * @param {string} userId ID of the user to delete SSH key from
         * @param {string} keyId ID of the SSH key to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSSHKey: async (userId: string, keyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteSSHKey', 'userId', userId)
            // verify required parameter 'keyId' is not null or undefined
            assertParamExists('deleteSSHKey', 'keyId', keyId)
            const localVarPath = `/api/v1.0/users/{userId}/sshkeys/{keyId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"keyId"}}`, encodeURIComponent(String(keyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete user (remove SFTP app and N6 entity)
         * @param {string} userId ID of the user to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteUser', 'userId', userId)
            const localVarPath = `/api/v1.0/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edit SSH key of user
         * @param {string} userId ID of the user to edit SSH key for
         * @param {string} keyId ID of the SSH key to update
         * @param {SSHKeyEntity} sSHKeyEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSSHKey: async (userId: string, keyId: string, sSHKeyEntity: SSHKeyEntity, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('editSSHKey', 'userId', userId)
            // verify required parameter 'keyId' is not null or undefined
            assertParamExists('editSSHKey', 'keyId', keyId)
            // verify required parameter 'sSHKeyEntity' is not null or undefined
            assertParamExists('editSSHKey', 'sSHKeyEntity', sSHKeyEntity)
            const localVarPath = `/api/v1.0/users/{userId}/sshkeys/{keyId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"keyId"}}`, encodeURIComponent(String(keyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sSHKeyEntity, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all users by assignment ID
         * @param {string} assignmentId ID of the assignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsersByAssignmentId: async (assignmentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('getAllUsersByAssignmentId', 'assignmentId', assignmentId)
            const localVarPath = `/api/v1.0/users/assignments/{assignmentId}/users`
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches all users associated with a specific business group ID.
         * @summary Get all users by business group ID
         * @param {string} id The ID of the business group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsersByBusinessGroupId: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAllUsersByBusinessGroupId', 'id', id)
            const localVarPath = `/api/v1.0/users/business-group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get assignments by user ID
         * @param {string} userId ID of the user whose assignments are requested
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssignmentsByUserId: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getAssignmentsByUserId', 'userId', userId)
            const localVarPath = `/api/v1.0/users/{userId}/assignments`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get SSH keys of user
         * @param {string} userId ID of the user to retrieve SSH keys for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSSHKeysByUserId: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getSSHKeysByUserId', 'userId', userId)
            const localVarPath = `/api/v1.0/users/{userId}/sshkeys`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user by ID
         * @param {string} userId ID of the user to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserById: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserById', 'userId', userId)
            const localVarPath = `/api/v1.0/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user(s) by loginId
         * @param {string} loginId Login ID of the user to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserByLoginId: async (loginId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginId' is not null or undefined
            assertParamExists('getUserByLoginId', 'loginId', loginId)
            const localVarPath = `/api/v1.0/users/by-login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)

            if (loginId !== undefined) {
                localVarQueryParameter['loginId'] = loginId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List users visible to current platform user (by accessible BGs)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVisibleUsers: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1.0/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove assignment from user
         * @param {string} userId ID of the user from whom to remove the assignment
         * @param {string} assignmentId ID of the assignment to remove from the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAssignment: async (userId: string, assignmentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('removeAssignment', 'userId', userId)
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('removeAssignment', 'assignmentId', assignmentId)
            const localVarPath = `/api/v1.0/users/{userId}/assignments/{assignmentId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"assignmentId"}}`, encodeURIComponent(String(assignmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reset user password (UMS only)
         * @param {string} userId ID of the user to reset password for
         * @param {ResetUserPasswordDto} resetUserPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetUserPassword: async (userId: string, resetUserPasswordDto: ResetUserPasswordDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('resetUserPassword', 'userId', userId)
            // verify required parameter 'resetUserPasswordDto' is not null or undefined
            assertParamExists('resetUserPassword', 'resetUserPasswordDto', resetUserPasswordDto)
            const localVarPath = `/api/v1.0/users/{userId}/reset-password`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetUserPasswordDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search user by Login ID
         * @param {string} searchId User Login ID to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUserByLoginId: async (searchId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchId' is not null or undefined
            assertParamExists('searchUserByLoginId', 'searchId', searchId)
            const localVarPath = `/api/v1.0/users/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)

            if (searchId !== undefined) {
                localVarQueryParameter['searchId'] = searchId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a user
         * @param {string} userId ID of the user to update
         * @param {UpdateUserDto} updateUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: async (userId: string, updateUserDto: UpdateUserDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUser', 'userId', userId)
            // verify required parameter 'updateUserDto' is not null or undefined
            assertParamExists('updateUser', 'updateUserDto', updateUserDto)
            const localVarPath = `/api/v1.0/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", ["openid", "profile", "email", "offline_access", "groups"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SFTPUsersApi - functional programming interface
 * @export
 */
export const SFTPUsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SFTPUsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add assignment to user (partial update)
         * @param {string} userId ID of the user to assign assignments to
         * @param {AddAssignmentDto} addAssignmentDto Assignment to add
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addAssignment(userId: string, addAssignmentDto: AddAssignmentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addAssignment(userId, addAssignmentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add SSH key to user (partial update)
         * @param {string} userId ID of the user to add an SSH key for
         * @param {SSHKeyEntity} sSHKeyEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addSSHKey(userId: string, sSHKeyEntity: SSHKeyEntity, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SSHKeyEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addSSHKey(userId, sSHKeyEntity, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update assignment membership for multiple users (bulk partial update)
         * @param {string} assignmentId ID of the assignment
         * @param {AssignUsersPayloadDto} assignUsersPayloadDto Payload containing users to add and remove from the assignment. Identifiers may be user &#x60;id&#x60; or &#x60;loginId&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignUsersToAssignment(assignmentId: string, assignUsersPayloadDto: AssignUsersPayloadDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignUsersToAssignment(assignmentId, assignUsersPayloadDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Add and/or remove assignments from a user in a single operation
         * @summary Manage user assignments (add and remove)
         * @param {string} userId ID of the user to manage assignments for
         * @param {ManageUserAssignmentsDto} manageUserAssignmentsDto Assignment IDs to add and remove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkAssignAssignments(userId: string, manageUserAssignmentsDto: ManageUserAssignmentsDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkAssignAssignments(userId, manageUserAssignmentsDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create multiple SFTP users in a single operation. Limited to 20 users per request due to CPU constraints. Each user follows the same validation and provisioning rules as single user creation. Users are processed independently - failures do not block other users. Assignments are optional and can be omitted.
         * @summary Create multiple users in bulk (max 20)
         * @param {BulkCreateUserDto} bulkCreateUserDto Array of users to create. Each user is validated independently.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkCreateUsers(bulkCreateUserDto: BulkCreateUserDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkCreateUsers(bulkCreateUserDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a new user
         * @param {CreateUserDto} createUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUser(createUserDto: CreateUserDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUser(createUserDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete SSH key of user
         * @param {string} userId ID of the user to delete SSH key from
         * @param {string} keyId ID of the SSH key to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSSHKey(userId: string, keyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SSHKeyEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSSHKey(userId, keyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete user (remove SFTP app and N6 entity)
         * @param {string} userId ID of the user to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUser(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteUserResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUser(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Edit SSH key of user
         * @param {string} userId ID of the user to edit SSH key for
         * @param {string} keyId ID of the SSH key to update
         * @param {SSHKeyEntity} sSHKeyEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editSSHKey(userId: string, keyId: string, sSHKeyEntity: SSHKeyEntity, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SSHKeyEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editSSHKey(userId, keyId, sSHKeyEntity, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all users by assignment ID
         * @param {string} assignmentId ID of the assignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllUsersByAssignmentId(assignmentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllUsersByAssignmentId(assignmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetches all users associated with a specific business group ID.
         * @summary Get all users by business group ID
         * @param {string} id The ID of the business group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllUsersByBusinessGroupId(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllUsersByBusinessGroupId(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get assignments by user ID
         * @param {string} userId ID of the user whose assignments are requested
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssignmentsByUserId(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssignmentEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssignmentsByUserId(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get SSH keys of user
         * @param {string} userId ID of the user to retrieve SSH keys for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSSHKeysByUserId(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SSHKeyEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSSHKeysByUserId(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get user by ID
         * @param {string} userId ID of the user to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserById(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserById(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get user(s) by loginId
         * @param {string} loginId Login ID of the user to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserByLoginId(loginId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserByLoginId(loginId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List users visible to current platform user (by accessible BGs)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listVisibleUsers(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listVisibleUsers(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove assignment from user
         * @param {string} userId ID of the user from whom to remove the assignment
         * @param {string} assignmentId ID of the assignment to remove from the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeAssignment(userId: string, assignmentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeAssignment(userId, assignmentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reset user password (UMS only)
         * @param {string} userId ID of the user to reset password for
         * @param {ResetUserPasswordDto} resetUserPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetUserPassword(userId: string, resetUserPasswordDto: ResetUserPasswordDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResetUserPassword200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetUserPassword(userId, resetUserPasswordDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Search user by Login ID
         * @param {string} searchId User Login ID to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchUserByLoginId(searchId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchUserByLoginId(searchId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a user
         * @param {string} userId ID of the user to update
         * @param {UpdateUserDto} updateUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUser(userId: string, updateUserDto: UpdateUserDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUser(userId, updateUserDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SFTPUsersApi - factory interface
 * @export
 */
export const SFTPUsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SFTPUsersApiFp(configuration)
    return {
        /**
         * 
         * @summary Add assignment to user (partial update)
         * @param {string} userId ID of the user to assign assignments to
         * @param {AddAssignmentDto} addAssignmentDto Assignment to add
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAssignment(userId: string, addAssignmentDto: AddAssignmentDto, options?: any): AxiosPromise<UserEntity> {
            return localVarFp.addAssignment(userId, addAssignmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add SSH key to user (partial update)
         * @param {string} userId ID of the user to add an SSH key for
         * @param {SSHKeyEntity} sSHKeyEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSSHKey(userId: string, sSHKeyEntity: SSHKeyEntity, options?: any): AxiosPromise<Array<SSHKeyEntity>> {
            return localVarFp.addSSHKey(userId, sSHKeyEntity, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update assignment membership for multiple users (bulk partial update)
         * @param {string} assignmentId ID of the assignment
         * @param {AssignUsersPayloadDto} assignUsersPayloadDto Payload containing users to add and remove from the assignment. Identifiers may be user &#x60;id&#x60; or &#x60;loginId&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignUsersToAssignment(assignmentId: string, assignUsersPayloadDto: AssignUsersPayloadDto, options?: any): AxiosPromise<Array<UserEntity>> {
            return localVarFp.assignUsersToAssignment(assignmentId, assignUsersPayloadDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Add and/or remove assignments from a user in a single operation
         * @summary Manage user assignments (add and remove)
         * @param {string} userId ID of the user to manage assignments for
         * @param {ManageUserAssignmentsDto} manageUserAssignmentsDto Assignment IDs to add and remove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkAssignAssignments(userId: string, manageUserAssignmentsDto: ManageUserAssignmentsDto, options?: any): AxiosPromise<UserEntity> {
            return localVarFp.bulkAssignAssignments(userId, manageUserAssignmentsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Create multiple SFTP users in a single operation. Limited to 20 users per request due to CPU constraints. Each user follows the same validation and provisioning rules as single user creation. Users are processed independently - failures do not block other users. Assignments are optional and can be omitted.
         * @summary Create multiple users in bulk (max 20)
         * @param {BulkCreateUserDto} bulkCreateUserDto Array of users to create. Each user is validated independently.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkCreateUsers(bulkCreateUserDto: BulkCreateUserDto, options?: any): AxiosPromise<void> {
            return localVarFp.bulkCreateUsers(bulkCreateUserDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new user
         * @param {CreateUserDto} createUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(createUserDto: CreateUserDto, options?: any): AxiosPromise<UserEntity> {
            return localVarFp.createUser(createUserDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete SSH key of user
         * @param {string} userId ID of the user to delete SSH key from
         * @param {string} keyId ID of the SSH key to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSSHKey(userId: string, keyId: string, options?: any): AxiosPromise<Array<SSHKeyEntity>> {
            return localVarFp.deleteSSHKey(userId, keyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete user (remove SFTP app and N6 entity)
         * @param {string} userId ID of the user to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(userId: string, options?: any): AxiosPromise<DeleteUserResponseDto> {
            return localVarFp.deleteUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edit SSH key of user
         * @param {string} userId ID of the user to edit SSH key for
         * @param {string} keyId ID of the SSH key to update
         * @param {SSHKeyEntity} sSHKeyEntity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSSHKey(userId: string, keyId: string, sSHKeyEntity: SSHKeyEntity, options?: any): AxiosPromise<Array<SSHKeyEntity>> {
            return localVarFp.editSSHKey(userId, keyId, sSHKeyEntity, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all users by assignment ID
         * @param {string} assignmentId ID of the assignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsersByAssignmentId(assignmentId: string, options?: any): AxiosPromise<Array<UserEntity>> {
            return localVarFp.getAllUsersByAssignmentId(assignmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetches all users associated with a specific business group ID.
         * @summary Get all users by business group ID
         * @param {string} id The ID of the business group.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsersByBusinessGroupId(id: string, options?: any): AxiosPromise<Array<UserEntity>> {
            return localVarFp.getAllUsersByBusinessGroupId(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get assignments by user ID
         * @param {string} userId ID of the user whose assignments are requested
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssignmentsByUserId(userId: string, options?: any): AxiosPromise<Array<AssignmentEntity>> {
            return localVarFp.getAssignmentsByUserId(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get SSH keys of user
         * @param {string} userId ID of the user to retrieve SSH keys for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSSHKeysByUserId(userId: string, options?: any): AxiosPromise<Array<SSHKeyEntity>> {
            return localVarFp.getSSHKeysByUserId(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user by ID
         * @param {string} userId ID of the user to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserById(userId: string, options?: any): AxiosPromise<UserEntity> {
            return localVarFp.getUserById(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user(s) by loginId
         * @param {string} loginId Login ID of the user to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserByLoginId(loginId: string, options?: any): AxiosPromise<Array<UserEntity>> {
            return localVarFp.getUserByLoginId(loginId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List users visible to current platform user (by accessible BGs)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVisibleUsers(options?: any): AxiosPromise<Array<UserEntity>> {
            return localVarFp.listVisibleUsers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove assignment from user
         * @param {string} userId ID of the user from whom to remove the assignment
         * @param {string} assignmentId ID of the assignment to remove from the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAssignment(userId: string, assignmentId: string, options?: any): AxiosPromise<UserEntity> {
            return localVarFp.removeAssignment(userId, assignmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reset user password (UMS only)
         * @param {string} userId ID of the user to reset password for
         * @param {ResetUserPasswordDto} resetUserPasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetUserPassword(userId: string, resetUserPasswordDto: ResetUserPasswordDto, options?: any): AxiosPromise<ResetUserPassword200Response> {
            return localVarFp.resetUserPassword(userId, resetUserPasswordDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search user by Login ID
         * @param {string} searchId User Login ID to search for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUserByLoginId(searchId: string, options?: any): AxiosPromise<Array<UserEntity>> {
            return localVarFp.searchUserByLoginId(searchId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a user
         * @param {string} userId ID of the user to update
         * @param {UpdateUserDto} updateUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(userId: string, updateUserDto: UpdateUserDto, options?: any): AxiosPromise<UserEntity> {
            return localVarFp.updateUser(userId, updateUserDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addAssignment operation in SFTPUsersApi.
 * @export
 * @interface SFTPUsersApiAddAssignmentRequest
 */
export interface SFTPUsersApiAddAssignmentRequest {
    /**
     * ID of the user to assign assignments to
     * @type {string}
     * @memberof SFTPUsersApiAddAssignment
     */
    readonly userId: string

    /**
     * Assignment to add
     * @type {AddAssignmentDto}
     * @memberof SFTPUsersApiAddAssignment
     */
    readonly addAssignmentDto: AddAssignmentDto
}

/**
 * Request parameters for addSSHKey operation in SFTPUsersApi.
 * @export
 * @interface SFTPUsersApiAddSSHKeyRequest
 */
export interface SFTPUsersApiAddSSHKeyRequest {
    /**
     * ID of the user to add an SSH key for
     * @type {string}
     * @memberof SFTPUsersApiAddSSHKey
     */
    readonly userId: string

    /**
     * 
     * @type {SSHKeyEntity}
     * @memberof SFTPUsersApiAddSSHKey
     */
    readonly sSHKeyEntity: SSHKeyEntity
}

/**
 * Request parameters for assignUsersToAssignment operation in SFTPUsersApi.
 * @export
 * @interface SFTPUsersApiAssignUsersToAssignmentRequest
 */
export interface SFTPUsersApiAssignUsersToAssignmentRequest {
    /**
     * ID of the assignment
     * @type {string}
     * @memberof SFTPUsersApiAssignUsersToAssignment
     */
    readonly assignmentId: string

    /**
     * Payload containing users to add and remove from the assignment. Identifiers may be user &#x60;id&#x60; or &#x60;loginId&#x60;.
     * @type {AssignUsersPayloadDto}
     * @memberof SFTPUsersApiAssignUsersToAssignment
     */
    readonly assignUsersPayloadDto: AssignUsersPayloadDto
}

/**
 * Request parameters for bulkAssignAssignments operation in SFTPUsersApi.
 * @export
 * @interface SFTPUsersApiBulkAssignAssignmentsRequest
 */
export interface SFTPUsersApiBulkAssignAssignmentsRequest {
    /**
     * ID of the user to manage assignments for
     * @type {string}
     * @memberof SFTPUsersApiBulkAssignAssignments
     */
    readonly userId: string

    /**
     * Assignment IDs to add and remove
     * @type {ManageUserAssignmentsDto}
     * @memberof SFTPUsersApiBulkAssignAssignments
     */
    readonly manageUserAssignmentsDto: ManageUserAssignmentsDto
}

/**
 * Request parameters for bulkCreateUsers operation in SFTPUsersApi.
 * @export
 * @interface SFTPUsersApiBulkCreateUsersRequest
 */
export interface SFTPUsersApiBulkCreateUsersRequest {
    /**
     * Array of users to create. Each user is validated independently.
     * @type {BulkCreateUserDto}
     * @memberof SFTPUsersApiBulkCreateUsers
     */
    readonly bulkCreateUserDto: BulkCreateUserDto
}

/**
 * Request parameters for createUser operation in SFTPUsersApi.
 * @export
 * @interface SFTPUsersApiCreateUserRequest
 */
export interface SFTPUsersApiCreateUserRequest {
    /**
     * 
     * @type {CreateUserDto}
     * @memberof SFTPUsersApiCreateUser
     */
    readonly createUserDto: CreateUserDto
}

/**
 * Request parameters for deleteSSHKey operation in SFTPUsersApi.
 * @export
 * @interface SFTPUsersApiDeleteSSHKeyRequest
 */
export interface SFTPUsersApiDeleteSSHKeyRequest {
    /**
     * ID of the user to delete SSH key from
     * @type {string}
     * @memberof SFTPUsersApiDeleteSSHKey
     */
    readonly userId: string

    /**
     * ID of the SSH key to delete
     * @type {string}
     * @memberof SFTPUsersApiDeleteSSHKey
     */
    readonly keyId: string
}

/**
 * Request parameters for deleteUser operation in SFTPUsersApi.
 * @export
 * @interface SFTPUsersApiDeleteUserRequest
 */
export interface SFTPUsersApiDeleteUserRequest {
    /**
     * ID of the user to delete
     * @type {string}
     * @memberof SFTPUsersApiDeleteUser
     */
    readonly userId: string
}

/**
 * Request parameters for editSSHKey operation in SFTPUsersApi.
 * @export
 * @interface SFTPUsersApiEditSSHKeyRequest
 */
export interface SFTPUsersApiEditSSHKeyRequest {
    /**
     * ID of the user to edit SSH key for
     * @type {string}
     * @memberof SFTPUsersApiEditSSHKey
     */
    readonly userId: string

    /**
     * ID of the SSH key to update
     * @type {string}
     * @memberof SFTPUsersApiEditSSHKey
     */
    readonly keyId: string

    /**
     * 
     * @type {SSHKeyEntity}
     * @memberof SFTPUsersApiEditSSHKey
     */
    readonly sSHKeyEntity: SSHKeyEntity
}

/**
 * Request parameters for getAllUsersByAssignmentId operation in SFTPUsersApi.
 * @export
 * @interface SFTPUsersApiGetAllUsersByAssignmentIdRequest
 */
export interface SFTPUsersApiGetAllUsersByAssignmentIdRequest {
    /**
     * ID of the assignment
     * @type {string}
     * @memberof SFTPUsersApiGetAllUsersByAssignmentId
     */
    readonly assignmentId: string
}

/**
 * Request parameters for getAllUsersByBusinessGroupId operation in SFTPUsersApi.
 * @export
 * @interface SFTPUsersApiGetAllUsersByBusinessGroupIdRequest
 */
export interface SFTPUsersApiGetAllUsersByBusinessGroupIdRequest {
    /**
     * The ID of the business group.
     * @type {string}
     * @memberof SFTPUsersApiGetAllUsersByBusinessGroupId
     */
    readonly id: string
}

/**
 * Request parameters for getAssignmentsByUserId operation in SFTPUsersApi.
 * @export
 * @interface SFTPUsersApiGetAssignmentsByUserIdRequest
 */
export interface SFTPUsersApiGetAssignmentsByUserIdRequest {
    /**
     * ID of the user whose assignments are requested
     * @type {string}
     * @memberof SFTPUsersApiGetAssignmentsByUserId
     */
    readonly userId: string
}

/**
 * Request parameters for getSSHKeysByUserId operation in SFTPUsersApi.
 * @export
 * @interface SFTPUsersApiGetSSHKeysByUserIdRequest
 */
export interface SFTPUsersApiGetSSHKeysByUserIdRequest {
    /**
     * ID of the user to retrieve SSH keys for
     * @type {string}
     * @memberof SFTPUsersApiGetSSHKeysByUserId
     */
    readonly userId: string
}

/**
 * Request parameters for getUserById operation in SFTPUsersApi.
 * @export
 * @interface SFTPUsersApiGetUserByIdRequest
 */
export interface SFTPUsersApiGetUserByIdRequest {
    /**
     * ID of the user to retrieve
     * @type {string}
     * @memberof SFTPUsersApiGetUserById
     */
    readonly userId: string
}

/**
 * Request parameters for getUserByLoginId operation in SFTPUsersApi.
 * @export
 * @interface SFTPUsersApiGetUserByLoginIdRequest
 */
export interface SFTPUsersApiGetUserByLoginIdRequest {
    /**
     * Login ID of the user to retrieve
     * @type {string}
     * @memberof SFTPUsersApiGetUserByLoginId
     */
    readonly loginId: string
}

/**
 * Request parameters for removeAssignment operation in SFTPUsersApi.
 * @export
 * @interface SFTPUsersApiRemoveAssignmentRequest
 */
export interface SFTPUsersApiRemoveAssignmentRequest {
    /**
     * ID of the user from whom to remove the assignment
     * @type {string}
     * @memberof SFTPUsersApiRemoveAssignment
     */
    readonly userId: string

    /**
     * ID of the assignment to remove from the user
     * @type {string}
     * @memberof SFTPUsersApiRemoveAssignment
     */
    readonly assignmentId: string
}

/**
 * Request parameters for resetUserPassword operation in SFTPUsersApi.
 * @export
 * @interface SFTPUsersApiResetUserPasswordRequest
 */
export interface SFTPUsersApiResetUserPasswordRequest {
    /**
     * ID of the user to reset password for
     * @type {string}
     * @memberof SFTPUsersApiResetUserPassword
     */
    readonly userId: string

    /**
     * 
     * @type {ResetUserPasswordDto}
     * @memberof SFTPUsersApiResetUserPassword
     */
    readonly resetUserPasswordDto: ResetUserPasswordDto
}

/**
 * Request parameters for searchUserByLoginId operation in SFTPUsersApi.
 * @export
 * @interface SFTPUsersApiSearchUserByLoginIdRequest
 */
export interface SFTPUsersApiSearchUserByLoginIdRequest {
    /**
     * User Login ID to search for
     * @type {string}
     * @memberof SFTPUsersApiSearchUserByLoginId
     */
    readonly searchId: string
}

/**
 * Request parameters for updateUser operation in SFTPUsersApi.
 * @export
 * @interface SFTPUsersApiUpdateUserRequest
 */
export interface SFTPUsersApiUpdateUserRequest {
    /**
     * ID of the user to update
     * @type {string}
     * @memberof SFTPUsersApiUpdateUser
     */
    readonly userId: string

    /**
     * 
     * @type {UpdateUserDto}
     * @memberof SFTPUsersApiUpdateUser
     */
    readonly updateUserDto: UpdateUserDto
}

/**
 * SFTPUsersApi - object-oriented interface
 * @export
 * @class SFTPUsersApi
 * @extends {BaseAPI}
 */
export class SFTPUsersApi extends BaseAPI {
    /**
     * 
     * @summary Add assignment to user (partial update)
     * @param {SFTPUsersApiAddAssignmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SFTPUsersApi
     */
    public addAssignment(requestParameters: SFTPUsersApiAddAssignmentRequest, options?: AxiosRequestConfig) {
        return SFTPUsersApiFp(this.configuration).addAssignment(requestParameters.userId, requestParameters.addAssignmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add SSH key to user (partial update)
     * @param {SFTPUsersApiAddSSHKeyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SFTPUsersApi
     */
    public addSSHKey(requestParameters: SFTPUsersApiAddSSHKeyRequest, options?: AxiosRequestConfig) {
        return SFTPUsersApiFp(this.configuration).addSSHKey(requestParameters.userId, requestParameters.sSHKeyEntity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update assignment membership for multiple users (bulk partial update)
     * @param {SFTPUsersApiAssignUsersToAssignmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SFTPUsersApi
     */
    public assignUsersToAssignment(requestParameters: SFTPUsersApiAssignUsersToAssignmentRequest, options?: AxiosRequestConfig) {
        return SFTPUsersApiFp(this.configuration).assignUsersToAssignment(requestParameters.assignmentId, requestParameters.assignUsersPayloadDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add and/or remove assignments from a user in a single operation
     * @summary Manage user assignments (add and remove)
     * @param {SFTPUsersApiBulkAssignAssignmentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SFTPUsersApi
     */
    public bulkAssignAssignments(requestParameters: SFTPUsersApiBulkAssignAssignmentsRequest, options?: AxiosRequestConfig) {
        return SFTPUsersApiFp(this.configuration).bulkAssignAssignments(requestParameters.userId, requestParameters.manageUserAssignmentsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create multiple SFTP users in a single operation. Limited to 20 users per request due to CPU constraints. Each user follows the same validation and provisioning rules as single user creation. Users are processed independently - failures do not block other users. Assignments are optional and can be omitted.
     * @summary Create multiple users in bulk (max 20)
     * @param {SFTPUsersApiBulkCreateUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SFTPUsersApi
     */
    public bulkCreateUsers(requestParameters: SFTPUsersApiBulkCreateUsersRequest, options?: AxiosRequestConfig) {
        return SFTPUsersApiFp(this.configuration).bulkCreateUsers(requestParameters.bulkCreateUserDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new user
     * @param {SFTPUsersApiCreateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SFTPUsersApi
     */
    public createUser(requestParameters: SFTPUsersApiCreateUserRequest, options?: AxiosRequestConfig) {
        return SFTPUsersApiFp(this.configuration).createUser(requestParameters.createUserDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete SSH key of user
     * @param {SFTPUsersApiDeleteSSHKeyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SFTPUsersApi
     */
    public deleteSSHKey(requestParameters: SFTPUsersApiDeleteSSHKeyRequest, options?: AxiosRequestConfig) {
        return SFTPUsersApiFp(this.configuration).deleteSSHKey(requestParameters.userId, requestParameters.keyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete user (remove SFTP app and N6 entity)
     * @param {SFTPUsersApiDeleteUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SFTPUsersApi
     */
    public deleteUser(requestParameters: SFTPUsersApiDeleteUserRequest, options?: AxiosRequestConfig) {
        return SFTPUsersApiFp(this.configuration).deleteUser(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edit SSH key of user
     * @param {SFTPUsersApiEditSSHKeyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SFTPUsersApi
     */
    public editSSHKey(requestParameters: SFTPUsersApiEditSSHKeyRequest, options?: AxiosRequestConfig) {
        return SFTPUsersApiFp(this.configuration).editSSHKey(requestParameters.userId, requestParameters.keyId, requestParameters.sSHKeyEntity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all users by assignment ID
     * @param {SFTPUsersApiGetAllUsersByAssignmentIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SFTPUsersApi
     */
    public getAllUsersByAssignmentId(requestParameters: SFTPUsersApiGetAllUsersByAssignmentIdRequest, options?: AxiosRequestConfig) {
        return SFTPUsersApiFp(this.configuration).getAllUsersByAssignmentId(requestParameters.assignmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetches all users associated with a specific business group ID.
     * @summary Get all users by business group ID
     * @param {SFTPUsersApiGetAllUsersByBusinessGroupIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SFTPUsersApi
     */
    public getAllUsersByBusinessGroupId(requestParameters: SFTPUsersApiGetAllUsersByBusinessGroupIdRequest, options?: AxiosRequestConfig) {
        return SFTPUsersApiFp(this.configuration).getAllUsersByBusinessGroupId(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get assignments by user ID
     * @param {SFTPUsersApiGetAssignmentsByUserIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SFTPUsersApi
     */
    public getAssignmentsByUserId(requestParameters: SFTPUsersApiGetAssignmentsByUserIdRequest, options?: AxiosRequestConfig) {
        return SFTPUsersApiFp(this.configuration).getAssignmentsByUserId(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get SSH keys of user
     * @param {SFTPUsersApiGetSSHKeysByUserIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SFTPUsersApi
     */
    public getSSHKeysByUserId(requestParameters: SFTPUsersApiGetSSHKeysByUserIdRequest, options?: AxiosRequestConfig) {
        return SFTPUsersApiFp(this.configuration).getSSHKeysByUserId(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user by ID
     * @param {SFTPUsersApiGetUserByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SFTPUsersApi
     */
    public getUserById(requestParameters: SFTPUsersApiGetUserByIdRequest, options?: AxiosRequestConfig) {
        return SFTPUsersApiFp(this.configuration).getUserById(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user(s) by loginId
     * @param {SFTPUsersApiGetUserByLoginIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SFTPUsersApi
     */
    public getUserByLoginId(requestParameters: SFTPUsersApiGetUserByLoginIdRequest, options?: AxiosRequestConfig) {
        return SFTPUsersApiFp(this.configuration).getUserByLoginId(requestParameters.loginId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List users visible to current platform user (by accessible BGs)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SFTPUsersApi
     */
    public listVisibleUsers(options?: AxiosRequestConfig) {
        return SFTPUsersApiFp(this.configuration).listVisibleUsers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove assignment from user
     * @param {SFTPUsersApiRemoveAssignmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SFTPUsersApi
     */
    public removeAssignment(requestParameters: SFTPUsersApiRemoveAssignmentRequest, options?: AxiosRequestConfig) {
        return SFTPUsersApiFp(this.configuration).removeAssignment(requestParameters.userId, requestParameters.assignmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reset user password (UMS only)
     * @param {SFTPUsersApiResetUserPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SFTPUsersApi
     */
    public resetUserPassword(requestParameters: SFTPUsersApiResetUserPasswordRequest, options?: AxiosRequestConfig) {
        return SFTPUsersApiFp(this.configuration).resetUserPassword(requestParameters.userId, requestParameters.resetUserPasswordDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search user by Login ID
     * @param {SFTPUsersApiSearchUserByLoginIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SFTPUsersApi
     */
    public searchUserByLoginId(requestParameters: SFTPUsersApiSearchUserByLoginIdRequest, options?: AxiosRequestConfig) {
        return SFTPUsersApiFp(this.configuration).searchUserByLoginId(requestParameters.searchId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a user
     * @param {SFTPUsersApiUpdateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SFTPUsersApi
     */
    public updateUser(requestParameters: SFTPUsersApiUpdateUserRequest, options?: AxiosRequestConfig) {
        return SFTPUsersApiFp(this.configuration).updateUser(requestParameters.userId, requestParameters.updateUserDto, options).then((request) => request(this.axios, this.basePath));
    }
}
